// @ts-nocheck
export const REPORTING_ADVANCED_FILTER_SET_CAMPAIGN_IDS = 'REPORTING_ADVANCED_FILTER_SET_CAMPAIGN_IDS';
export const REPORTING_ADVANCED_FILTER_SET_CURRENCY = 'REPORTING_ADVANCED_FILTER_SET_CURRENCY';
export const REPORTING_ADVANCED_FILTER_SET_TIME_RANGE = 'REPORTING_ADVANCED_FILTER_SET_TIME_RANGE';
export const REPORTING_ADVANCED_FILTER_SET_TIME_FRAME = 'REPORTING_ADVANCED_FILTER_SET_TIME_FRAME';
export const REPORTING_ADVANCED_FILTER_SET_TIMEZONE = 'REPORTING_ADVANCED_FILTER_SET_TIMEZONE';
export const REPORTING_ADVANCED_FILTER_SET_SETTINGS = 'REPORTING_ADVANCED_FILTER_SET_SETTINGS';
export const REPORTING_ADVANCED_FILTER_APPLY_SETTINGS = 'REPORTING_ADVANCED_FILTER_APPLY_SETTINGS';
export const REPORTING_ADVANCED_FILTER_RESET = 'REPORTING_ADVANCED_FILTER_RESET';
export const REPORTING_ADVANCED_FILTER_RESET_SECTION = 'REPORTING_ADVANCED_FILTER_RESET_SECTION';
export const REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_CATALOG =
  'REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_CATALOG';
export const REPORTING_ADVANCED_FILTER_SET_TABLE_TIME_STEP = 'REPORTING_ADVANCED_FILTER_SET_TABLE_TIME_STEP';
export const REPORTING_ADVANCED_FILTER_SET_TABLES_TIME_STEP = 'REPORTING_ADVANCED_FILTER_SET_TABLES_TIME_STEP';
export const REPORTING_ADVANCED_FILTER_SET_CHARTS_TIME_STEP = 'REPORTING_ADVANCED_FILTER_SET_CHARTS_TIME_STEP';
export const REPORTING_ADVANCED_FILTER_SET_COUNTRY = 'REPORTING_ADVANCED_FILTER_SET_COUNTRY';
export const REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_COUNTRIES =
  'REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_COUNTRIES';
export const REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL = 'REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL';
export const REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_IDS =
  'REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_IDS';
export const REPORTING_ADVANCED_FILTER_SET_MAPS = 'REPORTING_ADVANCED_FILTER_SET_MAPS';
export const REPORTING_ADVANCED_FILTER_DELETE_MAP = 'REPORTING_ADVANCED_FILTER_DELETE_MAP';
export const REPORTING_ADVANCED_FILTER_RESET_CARTOGRAPHY = 'REPORTING_ADVANCED_FILTER_RESET_CARTOGRAPHY';
export const REPORTING_ADVANCED_FILTER_SET_INSIGHT_COUNTRY = 'REPORTING_ADVANCED_FILTER_SET_INSIGHT_COUNTRY';

export const defaultSection = 'general';

export const reportingAdvancedFilterSetCampaignIds = cids => {
  return {
    data: { cids },
    type: REPORTING_ADVANCED_FILTER_SET_CAMPAIGN_IDS
  };
};

export const reportingAdvancedFilterSetCurrency = (currency, section = defaultSection) => {
  return {
    data: {
      currency,
      section
    },
    type: REPORTING_ADVANCED_FILTER_SET_CURRENCY
  };
};

export const reportingAdvancedFilterSetTimeRange = (timeRange, section = defaultSection) => {
  return {
    data: {
      section,
      timeRange
    },
    type: REPORTING_ADVANCED_FILTER_SET_TIME_RANGE
  };
};

export const reportingAdvancedFilterSetTimeFrame = (timeFrame, section = defaultSection, hasCustomDates = false) => {
  return {
    data: {
      hasCustomDates,
      section,
      timeFrame
    },
    type: REPORTING_ADVANCED_FILTER_SET_TIME_FRAME
  };
};

export const reportingAdvancedFilterSetTimeZone = (timeZone, section = defaultSection) => {
  return {
    data: {
      section,
      timeZone
    },
    type: REPORTING_ADVANCED_FILTER_SET_TIMEZONE
  };
};

export const reportAdvancedFilterSetSettings = (settings, section = defaultSection) => {
  return {
    data: {
      section,
      settings
    },
    type: REPORTING_ADVANCED_FILTER_SET_SETTINGS
  };
};

export const reportAdvancedFilterApplySettings = (section = defaultSection) => {
  return {
    data: { section },
    type: REPORTING_ADVANCED_FILTER_APPLY_SETTINGS
  };
};

export const reportAdvancedFilterResetSettings = () => {
  return { type: REPORTING_ADVANCED_FILTER_RESET };
};

export const reportAdvancedFilterResetSection = (section = defaultSection) => {
  return {
    data: { section },
    type: REPORTING_ADVANCED_FILTER_RESET_SECTION
  };
};

export const reportAdvancedFilterSetMaps = (section = defaultSection, mapId) => {
  return {
    data: {
      mapId,
      section
    },
    type: REPORTING_ADVANCED_FILTER_SET_MAPS
  };
};

export const reportAdvancedFilterDeleteMap = (section = defaultSection, mapId) => {
  return {
    data: {
      mapId,
      section
    },
    type: REPORTING_ADVANCED_FILTER_DELETE_MAP
  };
};

export const reportingAdvancedFilterResetCartography = (section = defaultSection, mapId) => {
  return {
    data: {
      mapId,
      section
    },
    type: REPORTING_ADVANCED_FILTER_RESET_CARTOGRAPHY
  };
};

export const reportAdvancedFilterSetCartographyCountries = (cartographyCountries, section = defaultSection, mapId) => {
  return {
    data: {
      cartographyCountries,
      mapId,
      section
    },
    type: REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_COUNTRIES
  };
};

export const reportAdvancedFilterSetCartographyLevel = (cartographyLevel, section = defaultSection, mapId) => {
  return {
    data: {
      cartographyLevel,
      mapId,
      section
    },
    type: REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL
  };
};

export const reportAdvancedFilterSetCartographyLevelIds = (cartographyLevelIds, section = defaultSection, mapId) => {
  return {
    data: {
      cartographyLevelIds,
      mapId,
      section
    },
    type: REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_IDS
  };
};

export const reportAdvancedFilterSetCartographyLevelCatalog = (
  cartographyLevelIdsCatalog,
  section = defaultSection
) => {
  return {
    data: {
      cartographyLevelIdsCatalog,
      section
    },
    type: REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_CATALOG
  };
};

export const reportAdvancedFilterSetTableTimeStep = (table, timeStep, section = defaultSection) => {
  return {
    data: {
      section,
      table,
      timeStep
    },
    type: REPORTING_ADVANCED_FILTER_SET_TABLE_TIME_STEP
  };
};

export const reportAdvancedFilterSetTablesTimeStep = (tablesTimeStep, section = defaultSection) => {
  return {
    data: {
      section,
      tablesTimeStep
    },
    type: REPORTING_ADVANCED_FILTER_SET_TABLES_TIME_STEP
  };
};

export const reportAdvancedFilterSetChartTimeStep = (timeStep, section = defaultSection) => {
  return {
    data: {
      section,
      timeStep
    },
    type: REPORTING_ADVANCED_FILTER_SET_CHARTS_TIME_STEP
  };
};

export const reportAdvancedFilterSetCountry = (country, section) => {
  return {
    data: {
      country,
      section
    },
    type: REPORTING_ADVANCED_FILTER_SET_COUNTRY
  };
};

export const reportAdvancedFilterSetInsightCountry = (country, insightId) => {
  return {
    data: {
      country,
      insightId
    },
    type: REPORTING_ADVANCED_FILTER_SET_INSIGHT_COUNTRY
  };
};
